import { createApi } from '@reduxjs/toolkit/query/react'
import { CREATE_CLASSROOM_REPORT_COPY, GET_REPORT_ASSESMENT_FEEDBACK, LIST_CLASSROOM_REPORTS, START_NEW_REPORT, SUBMIT_CONSULTATION_REPORT, SUBMIT_INDIVIDUAL_SESSION_REPORT, SUBMIT_SCHOOL_DISCHARGE_SCREENING_REPORT } from 'config/apiPaths';
import axiosBaseQuery from "utils/axios/axiosBaseQuery"
import { schoolClientsApi } from '../school.client';
import { ClassroomConsultationApi } from 'store/services/classroom';

export const classroomReportApi = createApi({
    reducerPath: 'classroomReportApi',
    baseQuery: axiosBaseQuery({
        baseUrl: "/classroom/report/classroom-consultation-plan",
    }),
    tagTypes: [],
    endpoints: (builder) => ({
        // clients list lookup
        getAssessmentFeedback: builder.query({
            query: ({ reportId, classroomId }) => ({
                method: "GET",
                url: `/view/${reportId}/${classroomId}`,
                // data
            }),
            transformResponse: (response) => {
                return response.data;
            },
        }),

        submitClassroomReport: builder.mutation({
            query: ({ reportId, data }) => ({
                method: "PATCH",
                url: `/submit/${reportId ? reportId : ""}`,
                data
            }),
            async onQueryStarted(id, { dispatch, queryFulfilled }) {
                try {
                    await queryFulfilled;

                    // Manually invalidate cache for 'Post' tag
                    dispatch(ClassroomConsultationApi.util.invalidateTags(['ClassroomReportsList']));
                } catch (error) {
                    // handle error if needed
                    console.log('error', error)
                }
            },
        }),

        startClassroomReport: builder.mutation({
            query: () => ({
                method: "PATCH",
                url: `${START_NEW_REPORT}`,
            }),
        }),


        createClassroomReportCopy: builder.mutation({
            query: ({ assessmentId, reportId, screening_date }) => ({
                method: "GET",
                url: `${CREATE_CLASSROOM_REPORT_COPY}/${assessmentId}/${reportId}${screening_date && `/?screening_date=${screening_date}`}`,
            }),
            async onQueryStarted(id, { dispatch, queryFulfilled }) {
                try {
                    await queryFulfilled;

                    // Manually invalidate cache for 'Post' tag
                    dispatch(ClassroomConsultationApi.util.invalidateTags(['ClassroomReportsList']));
                } catch (error) {
                    // handle error if needed
                    console.log('error', error)
                }
            },
        }),

        listClassroomReports: builder.query({
            query: ({ classroomId, page = 1, limit = 10, sort = { column: "id", direction: "DESC" } }) => ({
                method: "PATCH",
                url: `${LIST_CLASSROOM_REPORTS}/${classroomId}`,
                data: {
                    completed: "complete",
                    sort,
                    page,
                    limit
                }
            }),
            transformResponse: (response) => {
                return response.data;
            },
        }),

        getClassroomReport: builder.query({
            query: ({ reportId, assessmentId }) => ({
                method: "GET",
                url: `/view/${assessmentId}/${reportId}`,
                // data
            }),
            transformResponse: (response) => {
                return response.data;
            },
        }),
    })
})

export const {
    useGetAssessmentFeedbackQuery,
    useSubmitClassroomReportMutation,
    useListClassroomReportsQuery,
    useCreateClassroomReportCopyMutation,
    useStartClassroomReportMutation,
    useGetClassroomReportQuery
} = classroomReportApi;